import type { PercentileColorScheme } from "@/types/percentileColors"

export const PALETTE: Record<string, string> = {
  red: "#e74c3c",
  yellow: "#f1c40f",
  "green-3": "#6BBF59",
  green: "#08A045",
  "green-1": "#0B6E4F",
  orange: "#F97316",
  blue: "#3B82F6",
  purple: "#8B5CF6",
  gray: "#9CA3AF",
}

// Darkened overrides for text legibility on white backgrounds
const TEXT_COLOR_OVERRIDES: Record<string, string> = {
  "#f1c40f": "#c8a000",
}

export const DEFAULT_PERCENTILE_COLOR_SCHEME: PercentileColorScheme = [
  { min: 0, max: 20, color: "red" },
  { min: 20, max: 40, color: "yellow" },
  { min: 40, max: 60, color: "green-3" },
  { min: 60, max: 80, color: "green" },
  { min: 80, max: 100, color: "green-1" },
]

export function resolveColor(color: string): string {
  return PALETTE[color] ?? color
}

export function resolveTextColor(color: string): string {
  const hex = resolveColor(color)
  return TEXT_COLOR_OVERRIDES[hex] ?? hex
}

export function hexToRgba(hex: string, alpha: number): string {
  const r = Number.parseInt(hex.slice(1, 3), 16)
  const g = Number.parseInt(hex.slice(3, 5), 16)
  const b = Number.parseInt(hex.slice(5, 7), 16)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

export function getPercentileColor(
  percentile: number,
  scheme: PercentileColorScheme = DEFAULT_PERCENTILE_COLOR_SCHEME,
): string {
  const clamped = Math.max(0, Math.min(100, percentile))
  for (let i = 0; i < scheme.length; i++) {
    const band = scheme[i]
    const isLast = i === scheme.length - 1
    if (
      clamped >= band.min &&
      (clamped < band.max || (isLast && clamped <= 100))
    ) {
      return resolveColor(band.color)
    }
  }
  // Fallback: default scheme (guards against empty/gapped custom schemes)
  return getPercentileColor(percentile, DEFAULT_PERCENTILE_COLOR_SCHEME)
}
